module.exports = __webpack_public_path__ + "static/media/partner-story-ad1.355bc186.png";